/* eslint-disable react/no-multi-comp */

import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  Container,
  Icon,
  Menu,
  Segment,
  Sidebar,
} from 'semantic-ui-react'

import { ReactComponent as Logo } from '../../assets/logo.svg'
import { Navigation } from '../navigation'

export const MobileContainer = React.forwardRef((props, ref) => {
  const { children, current } = props
  const [sidebarOpened, setSidebarOpened] = useState(false)

  return (
    <Sidebar.Pushable>
      <Sidebar
        as={Menu}
        animation='overlay'
        inverted
        onHide={() => setSidebarOpened(false)}
        vertical
        visible={sidebarOpened}
      >
        <Navigation
          mobile
          current={current}
          ref={ref}
        />
      </Sidebar>
      <Sidebar.Pusher dimmed={sidebarOpened}>
        <Segment
          inverted
          textAlign='center'
          style={{ padding: '1em 0em' }}
          vertical
        >
          <Container>
            <Menu inverted pointing secondary size='large'>
              <Menu.Item onClick={() => setSidebarOpened(!sidebarOpened)}>
                <Icon name='sidebar' />
              </Menu.Item>
              <Menu.Item>
                <Logo className="navbar-logo" />
              </Menu.Item>
            </Menu>
          </Container>
          {/* <HomepageHeading mobile />*/}
        </Segment>
        {children}
      </Sidebar.Pusher>
    </Sidebar.Pushable>
  )
})

MobileContainer.propTypes = {
  children: PropTypes.node,
}